import { Button, Grid2, IconButton, Typography } from "@mui/material";
import classNames from "classnames";
import { useForm, useWatch } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import { TFlightLog } from "../../../../../@types";
import { apis, callApi } from "../../../../../api";
import { validators } from "../../../../../utils";
import { CommonInput } from "../../../../common";

export type TEditFlightDetailProps = {
	cancelEdit: () => void;
	flightLog: TFlightLog;
	updateFlightLogData: (id: number, flightLog: TFlightLog) => void;
};

export type TEditFlightDetailFieldValues = {
	description: string;
	landing: string;
};

export function EditFlightDetail(props: TEditFlightDetailProps) {
	const { control, handleSubmit, formState } =
		useForm<TEditFlightDetailFieldValues>({
			defaultValues: {
				description: props.flightLog.description ?? "",
				landing: props.flightLog.landing ?? "",
			},
			mode: "all",
		});

	const { description, landing } = useWatch({ control });

	const onClickEditFlightDetail = async (
		data: TEditFlightDetailFieldValues,
	) => {
		try {
			const body: Partial<{
				description?: string;
				landing?: string;
				shared?: boolean;
			}> = {};
			if (data.description !== (props.flightLog.description ?? "")) {
				body.description = data.description.trim();
			}

			if (data.landing !== (props.flightLog.landing ?? "")) {
				body.landing = data.landing;
			}

			// if (data.shared !== props.flightLog.shared) {
			// 	body.shared = data.shared;
			// }

			const response = await callApi({
				method: "PATCH",
				url: `${apis.FLIGHT_LOGS}/${props.flightLog.id}`,
				body,
			});

			if (!response) {
				return;
			}

			props.updateFlightLogData(props.flightLog.id ?? 0, response.flightInfo);
		} catch (error) {}
	};

	const buttonDisabled =
		(description?.trim() === (props.flightLog.description ?? "") &&
			landing?.trim() === (props.flightLog.landing ?? "")) ||
		Object.keys(formState.errors).length > 0;

	return (
		<Grid2
			size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}
			className="flight-log-detail">
			<div className="flight-log-detail-header">
				<IconButton onClick={props.cancelEdit}>
					<FaChevronLeft className="normal-icon" />
				</IconButton>
				<Typography className="normal-text">Edit Flight Takeaways</Typography>
			</div>
			<form
				className="flight-log-detail-content"
				onSubmit={handleSubmit(onClickEditFlightDetail)}>
				<Typography className="normal-text">Takeaways</Typography>
				<CommonInput
					control={control}
					name="description"
					placeholder="Enter Takeaways"
					multiline
				/>

				<Typography marginTop="16px" className="normal-text">
					Landings
				</Typography>
				<CommonInput
					control={control}
					name="landing"
					placeholder="Enter Landings"
					rules={{
						pattern: {
							value: validators.integer,
							message: "Please enter an integer",
						},
					}}
				/>

				<div className="save-button-container">
					<Button
						type="submit"
						disabled={buttonDisabled}
						className={classNames("normal-button save-button", {
							"primary-button": !buttonDisabled,
							"disabled-button": buttonDisabled,
						})}>
						Save
					</Button>
				</div>
			</form>
		</Grid2>
	);
}
